<template>
    <div class="relative p-4 wrapper-track">
        <div style="pointer-events: none;">
            <a-image
                :preview="{ visible: false }"
                class="image-center banner"
                alt="มหายันต์ลูกกอ"
                src="https://namahayan.blob.core.windows.net/assets/banner.webp"
            ></a-image>
        </div>
        <!-- <div v-if="!checklogin">
            <a-button type="primary" class="btn_accept " html-type="submit"
                >สมัครสมาชิก</a-button
            >
        </div> -->
        <!-- <pre>{{ register_form }}</pre> -->
        <div
            v-show="!isload"
            class="bg-register container mx-auto px-4 drop-shadow-xl"
        >
            <div v-if="!disable_register">
                <div class="text-center ">
                    <h1 class="font-semibold"><u>ลงทะเบียนสมาชิก</u></h1>
                </div>
                <a-form
                    :model="register_form"
                    v-bind="layout"
                    name="nest-messages"
                    :validate-messages="validateMessages"
                    @submit.prevent="onFinish"
                    @finishFailed="onFinishFailed"
                >
                    <a-form-item
                        :name="['user', 'name']" 
                        :rules="[
                            { required: true, message: 'กรุณากรอกข้อมูล' }
                        ]"
                    >
                    <div>ชื่อ</div>
                        <a-input v-model:value="register_form.user.name" />
                    </a-form-item>
                    <a-form-item
                        :name="['user', 'lastname']" 
                        :rules="[
                            { required: true, message: 'กรุณากรอกข้อมูล' }
                        ]"
                    >
                    <div>นามสกุล</div>
                        <a-input v-model:value="register_form.user.lastname" />
                    </a-form-item>
                    <a-form-item
                        :name="['user', 'nickname']" 
                        :rules="[
                            { required: true, message: 'กรุณากรอกข้อมูล' }
                        ]"
                    >
                    <div>ชื่อเล่น</div>
                        <a-input v-model:value="register_form.user.nickname" />
                    </a-form-item>
                    <a-form-item
                        :name="['user', 'phone']" 
                        :rules="[
                            { required: true, message: 'กรุณากรอกข้อมูล' }
                        ]"
                    >
                    <div>เบอร์โทรติดต่อ</div>
                        <a-input v-model:value="register_form.user.phone" />
                    </a-form-item>

                    <!-- <pre>{{ listoptions }}</pre> -->
                    <div class="center-container">
                        <a-radio-group
                            class=""
                            name="typeaddress"
                            @change="checkclear()"
                            v-model:value="register_form.user.typeaddress"
                        >
                            <a-radio :style="radioStyle" :value="'1'"
                                >ในประเทศ</a-radio
                            >
                            <a-radio :style="radioStyle" :value="'2'">
                                ต่างประเทศ
                            </a-radio>
                        </a-radio-group>
                        <a-form-item
                            style="padding-top: 20px;"
                            v-if="register_form.user.typeaddress == '1'"
                            label=""
                            :rules="{
                                required: true,
                                message: 'กรุณากรอกข้อมูล'
                            }"
                        >
                            <Address
                                :setprovince="register_form.user.provincename"
                                :setdistricts="register_form.user.bordername"
                                :setsubdistricts="
                                    register_form.user.districtname
                                "
                                :setpostcode="register_form.user.postcode"
                                @province="onprovince($event)"
                                @districts="ondistricts($event)"
                                @subdistricts="onsubdistricts($event)"
                                @postcode="onpostcode($event)"
                                :key="updatecomponent"
                            ></Address>
                        </a-form-item>
                        <a-form-item
                            style="padding-top: 20px;"
                            v-if="
                                register_form.user.typeaddress == '2' &&
                                    listoptions.length > 0
                            "
                            :name="['user', 'selectcountry']"
                            label="เลือกประเทศ*"
                            :rules="[
                                { required: false, message: 'กรุณากรอกข้อมูล' }
                            ]"
                        >
                            <div>
                                <a-select
                                    show-search
                                    v-model:value="
                                        register_form.user.selectcountry
                                    "
                                    placeholder="เลือกประเทศ"
                                    style="width: 200px"
                                    :options="listoptions"
                                    :filter-option="filterOption"
                                    @focus="handleFocus"
                                    @blur="handleBlur"
                                    @change="handleChange"
                                ></a-select>
                            </div>
                        </a-form-item>
                    </div>

                    <a-form-item
                        :name="['user', 'phone']" 
                        :rules="[
                            { required: true, message: 'กรุณากรอกข้อมูล' }
                        ]"
                    >
                    <div>บ้านเลขที่ ซอยและถนน</div>
                        <a-textarea
                            v-model:value="register_form.user.address"
                        />
                    </a-form-item>

                    <div class="text-center">
                        <a-button
                            class="register-btn mb-4 text-red-50"
                            style="color:white"
                            html-type="submit"
                            >ลงทะเบียน</a-button
                        >
                    </div>
                </a-form>
            </div>
            <div v-else>
                <a-result title="รายการนี้ได้ลงทะเบียนแล้ว">
                    <template #icon>
                        <smile-twoTone />
                    </template>
                </a-result>
            </div>
        </div>
        <!-- <div v-else>
            <a-alert message="เข้าสู่ระบบ เรียบร้อย" type="success" />
            <pre>{{ profile }}</pre>
        </div> -->

        <div class="loadline" v-if="isload">
            <div class="loadline text-green-600">
                <svg
                    class="spin-active"
                    width="20px"
                    height="20px"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                        <path
                            d="M7.706 0.290 C 7.484 0.362,7.356 0.490,7.294 0.699 C 7.259 0.816,7.253 1.088,7.253 2.508 C 7.253 4.389,7.251 4.365,7.443 4.557 C 7.700 4.813,8.300 4.813,8.557 4.557 C 8.749 4.365,8.747 4.389,8.747 2.508 C 8.747 0.688,8.744 0.656,8.596 0.480 C 8.472 0.333,8.339 0.284,8.040 0.276 C 7.893 0.272,7.743 0.278,7.706 0.290 M2.753 2.266 C 2.595 2.338,2.362 2.566,2.281 2.728 C 2.197 2.897,2.193 3.085,2.269 3.253 C 2.343 3.418,4.667 5.750,4.850 5.843 C 5.109 5.976,5.375 5.911,5.643 5.649 C 5.907 5.391,5.977 5.111,5.843 4.850 C 5.750 4.667,3.418 2.343,3.253 2.269 C 3.101 2.200,2.901 2.199,2.753 2.266 M12.853 2.282 C 12.730 2.339,12.520 2.536,11.518 3.541 C 10.597 4.464,10.316 4.762,10.271 4.860 C 10.195 5.025,10.196 5.216,10.272 5.378 C 10.342 5.528,10.572 5.764,10.727 5.845 C 10.884 5.927,11.117 5.926,11.280 5.843 C 11.447 5.757,13.757 3.447,13.843 3.280 C 13.926 3.118,13.927 2.884,13.846 2.729 C 13.764 2.572,13.552 2.364,13.392 2.283 C 13.213 2.192,13.048 2.192,12.853 2.282 M0.699 7.292 C 0.404 7.385,0.258 7.620,0.258 7.999 C 0.259 8.386,0.403 8.618,0.698 8.706 C 0.816 8.741,1.079 8.747,2.508 8.747 C 3.997 8.747,4.196 8.742,4.318 8.702 C 4.498 8.644,4.644 8.498,4.702 8.318 C 4.788 8.053,4.745 7.677,4.608 7.491 C 4.578 7.451,4.492 7.384,4.417 7.343 L 4.280 7.267 2.547 7.261 C 1.152 7.257,0.791 7.263,0.699 7.292 M11.745 7.278 C 11.622 7.308,11.452 7.411,11.392 7.492 C 11.255 7.677,11.212 8.053,11.298 8.318 C 11.356 8.498,11.502 8.644,11.682 8.702 C 11.804 8.742,12.003 8.747,13.492 8.747 C 14.921 8.747,15.184 8.741,15.302 8.706 C 15.597 8.618,15.741 8.386,15.742 7.999 C 15.742 7.614,15.595 7.383,15.290 7.291 C 15.187 7.260,14.864 7.254,13.496 7.256 C 12.578 7.258,11.790 7.268,11.745 7.278 M4.853 10.282 C 4.730 10.339,4.520 10.536,3.518 11.541 C 2.597 12.464,2.316 12.762,2.271 12.860 C 2.195 13.025,2.196 13.216,2.272 13.378 C 2.342 13.528,2.572 13.764,2.727 13.845 C 2.884 13.927,3.117 13.926,3.280 13.843 C 3.447 13.757,5.757 11.447,5.843 11.280 C 5.926 11.118,5.927 10.884,5.846 10.729 C 5.764 10.572,5.552 10.364,5.392 10.283 C 5.213 10.192,5.048 10.192,4.853 10.282 M10.753 10.266 C 10.595 10.338,10.362 10.566,10.281 10.728 C 10.197 10.897,10.193 11.085,10.269 11.253 C 10.343 11.418,12.667 13.750,12.850 13.843 C 13.109 13.976,13.375 13.911,13.643 13.649 C 13.907 13.391,13.977 13.111,13.843 12.850 C 13.750 12.667,11.418 10.343,11.253 10.269 C 11.101 10.200,10.901 10.199,10.753 10.266 M7.745 11.277 C 7.620 11.309,7.451 11.412,7.392 11.492 C 7.254 11.678,7.253 11.691,7.253 13.489 C 7.253 14.921,7.259 15.184,7.294 15.302 C 7.382 15.597,7.615 15.741,8.000 15.741 C 8.385 15.741,8.618 15.597,8.706 15.302 C 8.768 15.090,8.767 11.875,8.704 11.690 C 8.644 11.514,8.575 11.430,8.420 11.346 C 8.310 11.286,8.246 11.271,8.057 11.264 C 7.930 11.259,7.790 11.265,7.745 11.277 "
                            stroke="none"
                            fill-rule="evenodd"
                            fill="#167133"
                        ></path>
                    </g>
                </svg>
                <span class="p-3"> loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import liff from "@line/liff";
import { SmileTwoTone } from "@ant-design/icons-vue";
// import useLiff from "@/hooks/liff.js";
// const { liff, error } = useLiff();
// ในกรณีที่อยาก pass liffId ไป
// const { liff, error } = useLiff("abcdefg");
import TableLoad from "@/components/Skeleton/TableLoad";
import {
    onErrorCaptured,
    defineComponent,
    onMounted,
    ref,
    reactive,
    toRefs
} from "vue";
import {
    UserOutlined,
    SolutionOutlined,
    LoadingOutlined,
    SmileOutlined
} from "@ant-design/icons-vue";
import {
    GetProductBirthday,
    ProductBirthday
} from "@/core/Create/model/CreateModel";
import BzbsUser from "@/core/UserManagement/callapi/BzbsUser";
// import Drawer from "./Drawer.vue";
// import Previewslip from "../component/Previewslip.vue";
import moment from "moment";
import "moment/locale/th"; // without this line it didn't work
import Util from "@/helper/Utility";
// import BarcodeGenerator from "./BarcodeGenerator.vue";
import { Form, Input, Button } from "ant-design-vue";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import Locale from "@/helper/locale/Locale.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { FormHelper } from "@/helper/FormHelper.js";
import DatePickerDropdown from "@/components/Input/label/DatePickerDropdown.vue";
import Career from "@/components/Input/label/Career.vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import Address from "@/module/Sell/SellCreate/component/Address.vue";

export default defineComponent({
    mixins: [LocaleMixin],
    components: {
        Address,
        DatePickerDropdown,
        TableLoad,
        UserOutlined,
        SolutionOutlined,
        LoadingOutlined,
        SmileOutlined,
        MinusCircleOutlined,
        PlusOutlined,
        Career,
        SmileTwoTone
    },

    setup() {
        const router = useRouter();
        const route = useRoute();

        var customer_so = route.query.so;
        var customer_cuscode = route.query.cuscode;
        var customer_pk = route.query.pk;
        const ispaymentsuccess = ref(false);
        const errorOccurred = ref(false);

        onErrorCaptured((error, vm, info) => {
            // Handle the error here
            console.error("Error occurred during rendering:", error);
            console.error("Vue instance:", vm);
            console.error("Additional information:", info);

            // Update the errorOccurred flag
            errorOccurred.value = true;

            // Prevent the error from propagating further
            return false;
        });

        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        const track = ref("-");
        const cuscode = ref("-");
        const so = ref("-");
        const pk = ref("-");
        const current_status = ref(0);

        const searchInput = ref();
        const dataSources = ref(null);

        const getgreencard = ref([]);
        onMounted(() => {
            if (urlParams.has("so")) {
                so.value = urlParams.get("so") || "-";
            }
            if (urlParams.has("cuscode")) {
                cuscode.value = urlParams.get("cuscode") || "-";
            }
            if (urlParams.has("track")) {
                track.value = urlParams.get("track") || "-";
            }
            if (urlParams.has("pk")) {
                pk.value = urlParams.get("pk") || "-";
            }

            // querycustomer();
            // getimagegreen();
        });

        const numberOfPeople = ref(0);
        const getimagegreen = () => {
            return BzbsUser.getimagegreen(so.value)
                .then(res => {
                    getgreencard.value = res.data.find(
                        item =>
                            item.ProductKey == pk.value &&
                            item.ProductCustomerOrder == cuscode.value
                    );

                    let Shotness = getgreencard.value?.Shotness;

                    // ลบวงเล็บและตัวเลขออกจาก string
                    Shotness = Shotness.replace(/[()]/g, "");

                    if (
                        Shotness === "10" ||
                        Shotness === "20" ||
                        Shotness === "30" ||
                        Shotness === "40" ||
                        Shotness === "50"
                    ) {
                        // 10, 20, 30, 40, 50: 1 คน
                        numberOfPeople.value = 1;
                    } else if (Shotness === "789") {
                        // 789: 5 คน
                        numberOfPeople.value = 5;
                    } else if (Shotness === "88") {
                        // 88: 8 คน
                        numberOfPeople.value = 8;
                    } else if (Shotness === "100") {
                        // 100: 10 คน
                        numberOfPeople.value = 10;
                    } else {
                        // ค่าอื่นๆ
                        numberOfPeople.value = 0; // หรือสามารถกำหนดเป็นค่าอื่นๆ ตามที่ต้องการ
                    }
                    // alert(`จำนวนคน: ${numberOfPeople.value} คน`)
                    // console.log(`จำนวนคน: ${numberOfPeople.value} คน`);
                })
                .catch(error => {
                    console.log(error);
                });
        };

        const percent_current = size => {
            // คำนวณเปอร์เซ็นต์ของ Progress Bar โดยคิดเป็นจำนวนคนที่ได้รับหารด้วยจำนวนทั้งหมด
            return (size / numberOfPeople.value) * 100; // ค่าสูงสุดของ numberOfPeople เป็น 10
        };
        const formatdate = date => {
            return moment(date)
                .add(543, "year")
                .format("L");
        };

        const querycustomer = () => {
            return BzbsUser.getconsumerhistory(
                track.value,
                cuscode.value,
                so.value,
                pk.value
            )
                .then(res => {
                    dataSources.value = res.data;

                    checkstatuspayment();
                    // querycustomerdetail(res.data[0].CustomerOrder)
                })
                .catch(error => {
                    console.log(error);
                });
        };

        const checkstatuspayment = () => {
            var hasNotsuccess = false;

            dataSources.value.payment.forEach(element => {
                if (element.Checking != "checked") {
                    hasNotsuccess = true;
                }
            });

            if (hasNotsuccess) {
                ispaymentsuccess.value = false;
            } else {
                ispaymentsuccess.value = true;
            }
        };

        const getdatagreen = json => {
            return JSON.parse(JSON.stringify(json));
        };

        const gototrack = paramtrack => {
            if (urlParams.has("inter")) {
                window.location =
                    "/consumertrackinginter?track=" +
                    paramtrack +
                    "&cuscode=" +
                    cuscode.value +
                    "&inter=true";
            } else {
                window.location = "/consumertracking?cuscode=" + cuscode.value;
            }
        };

        const formRef = ref();
        const dynamicValidateForm = reactive({
            users: []
        });
        const removeUser = item => {
            let index = dynamicValidateForm.users.indexOf(item);
            if (index !== -1) {
                dynamicValidateForm.users.splice(index, 1);
            }
        };
        const addUser = () => {
            if (dynamicValidateForm.users.length == numberOfPeople.value)
                return;
            dynamicValidateForm.users.push({
                typebirthday: "2",
                name: "",
                lastname: "",
                nickname: "",
                idcard: "",
                gender: "", // Initialize gender field
                id: Date.now()
            });
        };
        const onFinishFailed = errorInfo => {
        
            Swal.fire({
                text: "กรุณากรอกข้อมูลให้ครบ",
                confirmButtonText: "ตกลง"
            });
        };
        const onFinish = values => {
            if (
                (register_form.user.provincename == "" ||
                    register_form.user.bordername == "" ||
                    register_form.user.districtname == "") &&
                register_form.user.typeaddress == "1"
            ) {
                Swal.fire({
                    text: "กรุณากรอกข้อมูลที่อยู่ให้ครบ",
                    confirmButtonText: "ตกลง"
                });
            } else if (
                register_form.user.selectcountry == "" &&
                register_form.user.typeaddress == "2"
            ) {
                Swal.fire({
                    text: "กรุณากรอกข้อมูลที่อยู่ให้ครบ",
                    confirmButtonText: "ตกลง"
                });
            } else {
                confirm();
            }
        };

        const clearaddress_one = () => {
            register_form.user.provincename = "";
            register_form.user.bordername = "";
            register_form.user.districtname = "";
        };
        const clearaddress_two = () => {
            register_form.user.selectcountry = "";
        };

        const confirm = () => {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                buttonsStyling: false
            });
            swalWithBootstrapButtons
                .fire({
                    text: "ยืนยันอัพเดทข้อมูล",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "ตกลง",
                    cancelButtonText: "ปิด",
                    reverseButtons: true
                })
                .then(result => {
                    if (result.isConfirmed) {
                        const line_profile_info = JSON.parse(
                            localStorage.getItem("profile") || "[]"
                        );
                        regsiter(line_profile_info);
                    }
                });
        };
        const daybirthrecommend = ref([]);
        const daybirth = (birthday, index) => {
            let lbl = Locale.getLbl();
            let day = lbl.date.date_full;
            var daycal = day[moment(birthday).format("d") - 1];
            daybirth_recommend(birthday, index);
        };
        const daybirth_recommend = (birthday, index) => {
            let lbl = Locale.getLbl();
            let day = lbl.date.date_full;
            var daycal = day[moment(birthday).format("d") - 1];
            if (moment(birthday).format("d") == 0) {
                daycal = day[6];
            }
            if (dynamicValidateForm.users[index]) {
                daybirthrecommend.value[index] = daycal;
            }
        };

        const calculateAgeDropdown = (sights, index) => {
            daybirth(sights, index);

            var ageDifMs = Date.now() - new Date(sights.birthday).getTime();
            var ageDate = new Date(ageDifMs); // miliseconds from epoch
            if (Math.abs(ageDate.getUTCFullYear() - 1970)) {
                return Math.abs(ageDate.getUTCFullYear() - 1970);
            } else {
                return 0;
            }
        };
        const isdisabled = (sights, index) => {
            if (sights.typebirthday == 1) {
                delete sights.birthday;
                delete sights.age;
                return true;
            } else {
                sights.age = calculateAgeDropdown(sights, index);
            }
        };

        const initproductbirthday = () => {
            var customercode = customer_cuscode;
            var productkey = customer_pk;
            var productsellorder = customer_so;
            BzbsUser.apigetproductbirthday(
                customercode,
                productkey,
                productsellorder
            )
                .then(res => {
                    const temp_obj = [];
                    res.data.forEach(element => {
                        var obj = new GetProductBirthday(element);
                        console.log("obj", obj);
                        temp_obj.push(obj);
                    });

                    dynamicValidateForm.users = temp_obj || [];
                })
                .catch(error => {
                    console.log(error);
                });
        };
        initproductbirthday();

        const update_birth_data = async () => {
            var count_index = 0;
            for await (let element of dynamicValidateForm.users) {
                element.productsellorder = customer_so;
                element.customerorder = customer_cuscode;
                element.productkey = customer_pk;

                let params = new ProductBirthday(element);

                await BzbsUser.apiupdateproductbirthday(params)
                    .then(res => {
                        console.log(res);
                        if (
                            dynamicValidateForm.users.length - 1 ==
                            count_index
                        ) {
                            Swal.fire({
                                title: "สำเร็จ!",
                                icon: "success",
                                cancelButtonText: "ปิด"
                            });
                        }

                        count_index = count_index + 1;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        };

        const disabledFutureDates = date => {
            return date && date.valueOf() > Date.now();
        };

        const isload = ref(false);
        const checklogin = ref(false);
        const linelogin = async () => {
            isload.value = true;
            const error = ref(null);
            const liffInstance = ref(null);
            await liff
                .init({ liffId: process.env.VUE_APP_BIRTHDATE_LIFF_ID })
                .then(async () => {
                    liffInstance.value = liff;
                    error.value = null;
                    if (!liff.isLoggedIn()) {
                        var destinationUrl = window.location.href;
                        liff.login();
                        setTimeout(() => {
                            isload.value = false;
                        }, 2000);
                    } else {
                        checklogin.value = true;

                        liff.getProfile()
                            .then(profile => {
                                localStorage.setItem(
                                    "profile",
                                    JSON.stringify(profile)
                                );
                                const userProfile = profile.userId;
                                const displayName = profile.displayName;
                                const statusMessage = profile.statusMessage;
                                const pictureUrl = profile.pictureUrl;

                                check_owner_account(profile);
                            })
                            .catch(err => console.error(err));
                        // alert("profile :",profile.value)

                        //
                    }
                })
                .catch(err => (error.value = err));
        };

        const disable_register = ref(false);
        const check_owner_account = async profile => {
           
            var params = {
                CustomerOrder: customer_cuscode
            };

            await BzbsUser.apicheckowneraccount(params)
                .then(res => {
                    if (res.data?.length > 0) {
                        const isUserIdFound = Boolean(
                            res.data.find(item => item.UserId != profile.userId)
                        );
                        if (isUserIdFound) {
                            Swal.fire({
                                title: `ผู้ใช้ ${res.data[0].CustomerOrder} ลงทะเบียนแล้ว`,
                                showConfirmButton: false
                            });
                            disable_register.value = true;
                        } else {
                            updateline_to_product(profile);
                            setTimeout(() => {
                                isload.value = false;
                                window.location =
                                    "/consumeryandetailbrithDay" +
                                    window.location.search;
                            }, 300);
                        }
                    } else {
                        setTimeout(() => {
                            isload.value = false;
                        }, 500);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        };

        const updateline_to_product = async profile => {
            var params = {
                ProductSellOrder: customer_so,
                ProductKey: customer_pk,
                CustomerOrder: customer_cuscode,
                UserId: profile.userId,
                DisplayName: profile.displayName,
                StatusMessage: profile.statusMessage,
                PictureUrl: profile.pictureUrl
            };

            await BzbsUser.apiupdatelineprofiletoproduct(params)
                .then(res => {
                    console.log(res);
                })
                .catch(error => {
                    console.log(error);
                });
        };
        const regsiter = async profile => {
            var params = {
                CustomerOrder: customer_cuscode,
                UserId: profile?.userId,
                DisplayName: profile?.displayName,
                StatusMessage: profile?.statusMessage,
                PictureUrl: profile?.pictureUrl,
                Name: register_form.user.name,
                LastName: register_form.user.lastname,
                NickName: register_form.user.nickname,
                Phone: register_form.user.phone,
                ProvinceName: register_form.user.provincename,
                BorderName: register_form.user.bordername,
                DistrictName: register_form.user.districtname,
                PostCode: register_form.user.postcode,
                TypeAddress: register_form.user.typeaddress,
                SelectCountry: register_form.user.selectcountry,
                ProvinceID: register_form.user.provinceid,
                Address: register_form.user.address,
                BorderID: register_form.user.borderid
            };

            await BzbsUser.apiregister(params)
                .then(res => {
                    setTimeout(() => {
                        window.location =
                            "/consumeryandetailbrithDay" +
                            window.location.search;
                    }, 300);
                })
                .catch(error => {
                    console.log(error);
                });
        };

        linelogin();

        const layout = {
            labelCol: {
                span: 8
            },
            wrapperCol: {
                span: 24
            }
        };
        const validateMessages = {
            required: "${label} is required!",
            types: {
                email: "${label} is not a valid email!",
                number: "${label} is not a valid number!"
            },
            number: {
                range: "${label} must be between ${min} and ${max}"
            }
        };
        const register_form = reactive({
            user: {
                name: "",
                age: undefined,
                introduction: "",
                provincename: "",
                bordername: "",
                districtname: "",
                postcode: "",
                typeaddress: "1",
                address: "",
                selectcountry: ""
            }
        });

        var listoptions = ref([]);
        const initapicountries = () => {
            BzbsUser.apicountries()
                .then(res => {
                    Object.keys(res.data).map(function(element) {
                        listoptions.value.push({
                            value: [
                                res.data[element].CountryNameTh,
                                res.data[element].CountryCode
                            ],
                            label: res.data[element].CountryNameTh
                        });
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        };
        initapicountries();

        const onprovince = values => {
            register_form.user.provincename = values.provinceName;
            register_form.user.provinceid = values.provinceID;
        };
        const ondistricts = values => {
            register_form.user.bordername = values.districtsName;
            register_form.user.borderid = values.districtsID;
        };
        const onsubdistricts = values => {
            register_form.user.districtid = values.subdistrictsID;
            register_form.user.districtname = values.subdistrictsName;
        };
        const onpostcode = values => {
            register_form.user.postcode = values;
        };

        const checkclear = () => {
            if (register_form.user.typeaddress == "1") clearaddress_two();
            if (register_form.user.typeaddress == "2") clearaddress_one();
        };
        return {
            onFinishFailed,
            disable_register,
            onprovince,
            ondistricts,
            onsubdistricts,
            onpostcode,
            listoptions,
            linelogin,
            isdisabled,
            gototrack,
            getgreencard,
            current_status,
            dataSources,
            querycustomer,
            formatdate,
            searchInput,
            Util,
            getdatagreen,
            pk,
            errorOccurred,
            ispaymentsuccess,
            formRef,
            dynamicValidateForm,
            onFinish,
            removeUser,
            addUser,
            errorInfo: FormHelper.genErrorInfo(7),
            daybirthrecommend,
            disabledFutureDates,
            numberOfPeople,
            percent_current,
            checklogin,
            register_form,
            layout,
            validateMessages,
            regsiter,
            isload,
            checkclear
        };
    }
});
</script>
<style lang="scss">
.loadline {
    min-height: 80vh;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
}

.spin-active {
    animation-name: spin;
    animation-duration: 4000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.center-container {
    display: flex; /* Or use display: grid; */
    justify-content: center; /* Or use align-items: center; */
    align-items: center; /* Or use justify-content: center; */
    flex-direction: column; /* If using flexbox */
    padding: 10px;
    /* Other styling as needed */
}

.bg-register {
    background-color: rgb(248 250 252);
    border-radius: 15px;
    padding-top: 15px;
    box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
}
.register-btn {
    background: linear-gradient(
        to right,
        #ee7724,
        #d8363a,
        #dd3675,
        #b44593
    ) !important;
}
</style>
